import { AnalyticsService } from "../../typescript/common/analytics-service";

(function dropdownMenuPage() {
  const pageElement: HTMLElement | null = document.querySelector('.dropdown-menu-page');
  if (pageElement) {
    class DropdownMenuPage {
      public init() {
        const dropDownButton = document.getElementById('dropdown-button');
        if (dropDownButton) {
          dropDownButton.addEventListener('click', () => {
            const dropDown = document.getElementById('dropdown') as HTMLSelectElement;
            const index = dropDown.selectedIndex;
            if (index > 0) {
              const url = new URL(dropDown.value, window.location.origin);
              url.hash = 's';
              window.location.assign(url);
            }
          });
        }

        const printButton = document.getElementById('dropdown-menu-page-print-button');
        if (printButton) {
          printButton.addEventListener('click', () => {
            AnalyticsService.addEvent(AnalyticsService.DropdownMenuPage, 'Klick på skriv ut', window.location.href);
            window.print();
          });
        }
      }
    }

    const page = new DropdownMenuPage();
    page.init();
  }
})();
